"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconButton = _interopRequireDefault(require("../iconButton"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Autocomplete = /*#__PURE__*/function (_PureComponent) {
  _inherits(Autocomplete, _PureComponent);

  var _super = _createSuper(Autocomplete);

  function Autocomplete() {
    var _this;

    _classCallCheck(this, Autocomplete);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // The active selection's index
      activeSuggestion: 0,
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // Whether or not the suggestion list is shown
      showSuggestions: false,
      // What the user has entered
      userInput: ""
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var _this$props = _this.props,
          suggestions = _this$props.suggestions,
          userInputValue = _this$props.userInputValue,
          showClearButton = _this$props.showClearButton;
      var userInput = e.currentTarget.value;

      if (showClearButton === "true") {
        userInputValue(userInput);
      } // Filter our suggestions that don't contain the user's input


      var filteredSuggestions = suggestions.filter(function (suggestion) {
        return suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1;
      });

      _this.setState({
        activeSuggestion: 0,
        filteredSuggestions: filteredSuggestions,
        showSuggestions: true,
        userInput: e.currentTarget.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPressClear", function (e) {
      _this.setState({
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: ""
      }), _this.props.userInputValue(e.currentTarget.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      _this.setState({
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: e.currentTarget.innerText
      });

      _this.props.userInputValue(e.currentTarget.innerText);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$state = _this.state,
          activeSuggestion = _this$state.activeSuggestion,
          filteredSuggestions = _this$state.filteredSuggestions; // User pressed the enter key

      if (e.keyCode === 13) {
        _this.setState({
          activeSuggestion: 0,
          showSuggestions: false,
          userInput: filteredSuggestions[activeSuggestion]
        });
      } else if (e.keyCode === 38) {
        if (activeSuggestion === 0) {
          return;
        }

        _this.setState({
          activeSuggestion: activeSuggestion - 1
        });
      } else if (e.keyCode === 40) {
        if (activeSuggestion - 1 === filteredSuggestions.length) {
          return;
        }

        _this.setState({
          activeSuggestion: activeSuggestion + 1
        });
      }
    });

    return _this;
  }

  _createClass(Autocomplete, [{
    key: "render",
    value: function render() {
      var onChange = this.onChange,
          onClick = this.onClick,
          onKeyDown = this.onKeyDown,
          onPressClear = this.onPressClear,
          _this$state2 = this.state,
          activeSuggestion = _this$state2.activeSuggestion,
          filteredSuggestions = _this$state2.filteredSuggestions,
          showSuggestions = _this$state2.showSuggestions,
          userInput = _this$state2.userInput;
      var _this$props2 = this.props,
          name = _this$props2.name,
          placeholder = _this$props2.placeholder,
          showClearButton = _this$props2.showClearButton;
      var suggestionsListComponent;

      if (showSuggestions && userInput) {
        if (filteredSuggestions.length) {
          suggestionsListComponent = /*#__PURE__*/_react.default.createElement("ul", {
            className: "suggestions"
          }, filteredSuggestions.map(function (suggestion, index) {
            var className; // Flag the active suggestion with a class

            if (index === activeSuggestion) {
              className = "suggestion-active";
            }

            return /*#__PURE__*/_react.default.createElement("li", {
              className: className,
              key: suggestion,
              onClick: onClick
            }, suggestion);
          }));
        } else {
          suggestionsListComponent = /*#__PURE__*/_react.default.createElement("div", {
            className: "no-suggestions"
          }, /*#__PURE__*/_react.default.createElement("em", null, "No suggestions"));
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "autocomplete-container"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        autoComplete: "off",
        name: name,
        placeholder: placeholder,
        onChange: onChange,
        onKeyDown: onKeyDown,
        value: userInput
      }), showClearButton === "true" && userInput !== "" && /*#__PURE__*/_react.default.createElement(_iconButton.default, {
        onClick: onPressClear,
        icon: "close"
      })), suggestionsListComponent);
    }
  }]);

  return Autocomplete;
}(_react.PureComponent);

_defineProperty(Autocomplete, "defaultProps", {
  suggestions: []
});

Autocomplete.propTypes = {
  suggestions: _propTypes.default.array,
  placeholder: _propTypes.default.string.isRequired,
  name: _propTypes.default.string,
  showClearButton: _propTypes.default.string.isRequired,
  userInputValue: _propTypes.default.func
};
var _default = Autocomplete;
exports.default = _default;